import algoliainsights from 'search-insights'

const ALGOLIA_APP = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID
const ALGOLIA_SEARCH_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY

const insightsClient = algoliainsights('init', { appId: ALGOLIA_APP, apiKey: ALGOLIA_SEARCH_API_KEY })

export default insightsClient
